var map = {
	"./aiSecurity/cn.json": [
		4105,
		61
	],
	"./dataLeakage/cn.json": [
		4106,
		64
	],
	"./ppd/cn.json": [
		4107,
		67
	],
	"./ransomware/cn.json": [
		4108,
		70
	],
	"./socialMedia/cn.json": [
		4109,
		73
	],
	"./whatsApp/cn.json": [
		4110,
		76
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 766;
module.exports = webpackAsyncContext;